import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import kfc from '../Resources/Images/Project/kfc.jpeg';
import FitnessBlender from '../Resources/Images/Project/fitnessBlender.jpeg';
import ESPN from '../Resources/Images/Project/ESPN.jpeg';
import ZARA from '../Resources/Images/Project/zara.jpg';
import ORGANICMARKET from '../Resources/Images/Project/organic-market.jpeg';
import OMMEINDIA from '../Resources/Images/Project/Ommeindia.jpeg';
import Weather from '../Resources/Images/Project/Weather.jpeg';
import GitHubIcon from '@mui/icons-material/GitHub';
import StreamIcon from '@mui/icons-material/Stream';

const Projects = () => {
    const projects = [
        {
            id: 7,
            title: 'Omme Electromech PVT.ltd',
            img: OMMEINDIA,
            desc: 'Omme Electromech Private Limited -  is a leading Exporter, Importer, Manufacturer, Supplier, Trading Company of Armature Testing Panel , Automatic Armature Testing Equipment, Armature Testing Equipment from Noida, Uttar Pradesh, India.',
            worked: 'This is a individual project which is created by me in 1 month for my client.',
            deployedLink: 'https://ommeindia.com/',
            tags: ['HTML', 'CSS', 'Javascript', 'React', 'Redux', 'Material UI', 'Chakra UI', 'Multer', 'JWT', 'bcrypt', 'Swiper', 'Mongoose', 'MongoDB', 'Express', 'Node.js']
        }, {
            id: 5,
            title: 'Weather App',
            img: Weather,
            desc: 'Weather App has local and international weather forecasts from the most accurate weather forecasting technology featuring up to the weekly weather reports.',
            worked: 'This is a individual project which is only created by me in 1 day.',
            githubLink: 'https://github.com/MoHitksS/weather-app',
            deployedLink: 'https://weather-app-ind.netlify.app/',
            tags: ['HTML', 'CSS', 'Javascript', 'React', 'Chakra UI']
        },
        {
            id: 6,
            title: 'ORGANIC MARKET',
            img: ORGANICMARKET,
            desc: 'The best online grocery store in India. bigbasket is an online supermarket for all your daily needs. Online shopping now made easy with a wide range of groceries and home needs.',
            worked: 'A collaborative project, built in 4 days by a team of 5 developers.',
            githubLink: 'https://github.com/MoHitksS/organic-market',
            deployedLink: 'https://organicmarket.netlify.app/',
            tags: ['HTML', 'CSS', 'Javascript', 'React', 'Redux', 'Material UI', 'Chakra UI', 'Multer', 'JWT', 'bcrypt', 'Swiper', 'Mongoose', 'MongoDB', 'Express', 'Node.js']
        }, {
            id: 3,
            title: 'ESPNcrickInfo Clone',
            img: ESPN,
            desc: 'Find Live Cricket Scores, Match updates, Fixtures, Results, News, Articles, Video highlights only at ESPNcricinfo. Read Ball by Ball Commentary',
            worked: 'This is a individual project which is only created by me in 4 days.',
            keyPoint2: 'Find interactive analysis of cricket stats and records only on ESPNcricinfo.com.',
            keyPoint1: 'ESPNcricinfo is available to cricket fans through the online media and on a host of mobile platforms and handheld devices.',
            githubLink: 'https://github.com/MoHitksS/rugged-driving-9905',
            deployedLink: 'https://espncrickinfoin.netlify.app/',
            tags: ['HTML', 'CSS', 'Javascript', 'React', 'Chakra UI']
        },

        {
            id: 4,
            title: 'ZARA ORIGINS Clone',
            img: ZARA,
            desc: 'Latest trends in clothing for women, men & kids at ZARA online. Find new arrivals, fashion catalogs, collections & lookbooks every week.',
            worked: 'A collaborative project, built in 4 days by a team of 5 developers.',
            githubLink: 'https://github.com/MoHitksS/green-value-83/',
            deployedLink: 'https://zara-origins.netlify.app/',
            tags: ['HTML', 'CSS', 'Javascript', 'React', 'Redux', 'Material UI', 'Firebase']
        },

        {
            id: 2,
            title: 'Fitness Blender Clone',
            img: FitnessBlender,
            desc: 'Fitness Blender provides hundreds of workouts, healthy recipes, relaxing meditations, and expert articles, for a whole body and mind approach to feeling great.',
            worked: 'A collaborative project, built in 4 days by a team of 5 developers.',
            keyPoint1: 'Exercise with certified personal trainers whether you\'re at home or on the road.',
            keyPoint2: 'Professionally designed programs take the guesswork out of exercising.',
            githubLink: 'https://github.com/MoHitksS/vengeful-thrill-8133',
            deployedLink: 'https://fitness-blender.netlify.app/',
            tags: ['HTML', 'CSS', 'Javascript']
        },
        {
            id: 1,
            title: 'KFC Clone',
            img: kfc,
            desc: 'KFC, a subsidiary of Yum! Brands, Inc. (NYSE: YUM.), is a global chicken restaurant brand with a rich, decades-long history of success and innovation.',
            worked: 'A collaborative project, built in 5 days by a team of 5 developers.',
            keyPoint2: 'Our food is always craveable. We are the original fried chicken experts, and everything we do celebrates our passion for serving finger lickin\' good food.',
            keyPoint1: 'KFC stores are located in more than 105 countries and were first opened in 1930.',
            githubLink: 'https://github.com/MoHitksS/KFC-india/',
            deployedLink: 'https://kfc-online-india.netlify.app/',
            tags: ['HTML', 'CSS', 'Javascript']
        }
    ]

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                duration: 0.6,
                staggerChildren: 0.2
            }
        },
        exit: {
            opacity: 0,
            transition: {
                duration: 0.4,
                staggerChildren: 0.1,
                staggerDirection: -1
            }
        }
    };

    const projectVariants = {
        hidden: { 
            opacity: 0, 
            y: 100,
            scale: 0.9
        },
        visible: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: {
                duration: 0.8,
                ease: "easeOut"
            }
        },
        exit: {
            opacity: 0,
            y: -100,
            scale: 0.9,
            transition: {
                duration: 0.5,
                ease: "easeIn"
            }
        }
    };

    const imageVariants = {
        hover: {
            scale: 1.1,
            transition: {
                duration: 0.4,
                ease: "easeInOut"
            }
        }
    };

    const buttonVariants = {
        hover: {
            y: -3,
            scale: 1.05,
            transition: {
                duration: 0.2,
                ease: "easeInOut"
            }
        },
        tap: {
            scale: 0.95
        }
    };

    const tagVariants = {
        hover: {
            scale: 1.1,
            backgroundColor: "#019a6b",
            transition: {
                duration: 0.2
            }
        }
    };

    return (
        <Container id='projects'>
            <motion.h1
                initial={{ opacity: 0, y: -30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                Projects
            </motion.h1>
            <motion.div 
                className='projectsContainer'
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                exit="exit"
                viewport={{ once: false, margin: "-100px" }}
            >
                {projects.map((ele, index) => (
                    <motion.div 
                        key={index} 
                        className="box"
                        variants={projectVariants}
                        whileHover={{ 
                            y: -10,
                            boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.15)",
                            transition: { duration: 0.3 }
                        }}
                    >
                        <motion.div className='imgBox'>
                            <img 
                                src={ele.img} 
                                alt={ele.title} 
                                width='100%'
                            />
                        </motion.div>
                        <motion.div 
                            className='ContentBox'
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                        >
                            <motion.h1
                                initial={{ opacity: 0 }}
                                whileInView={{ opacity: 1 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6, delay: 0.3 }}
                            >
                                {ele.title}
                            </motion.h1>
                            <motion.p
                                initial={{ opacity: 0 }}
                                whileInView={{ opacity: 1 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6, delay: 0.4 }}
                            >
                                {ele.desc}
                            </motion.p>
                            <motion.p 
                                style={{ fontWeight: 'bold' }}
                                initial={{ opacity: 0 }}
                                whileInView={{ opacity: 1 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6, delay: 0.5 }}
                            >
                                {ele.worked}
                            </motion.p>
                            <motion.div 
                                className='tagsBox'
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6, delay: 0.6 }}
                            >
                                {ele.tags.map((tag, tagIndex) => (
                                    <motion.span 
                                        key={tagIndex}
                                        variants={tagVariants}
                                        whileHover="hover"
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        whileInView={{ opacity: 1, scale: 1 }}
                                        viewport={{ once: true }}
                                        transition={{ 
                                            duration: 0.3, 
                                            delay: 0.7 + (tagIndex * 0.05)
                                        }}
                                    >
                                        {tag}
                                    </motion.span>
                                ))}
                            </motion.div>
                            <motion.div 
                                className='linkSection'
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6, delay: 0.8 }}
                            >
                                {ele.githubLink && 
                                    <a href={ele.githubLink} target='_blank' rel='noreferrer'>
                                        <motion.button
                                            variants={buttonVariants}
                                            whileHover="hover"
                                            whileTap="tap"
                                        >
                                            <GitHubIcon />Github
                                        </motion.button>
                                    </a>
                                }
                                <a href={ele.deployedLink} target='_blank' rel='noreferrer'>
                                    <motion.button
                                        variants={buttonVariants}
                                        whileHover="hover"
                                        whileTap="tap"
                                    >
                                        <StreamIcon />Live
                                    </motion.button>
                                </a>
                            </motion.div>
                        </motion.div>
                    </motion.div>
                ))}
            </motion.div>
        </Container>
    )
}


const Container = styled.div`
    width:100%;
    margin:auto;
    display:flex;
    flex-direction:column;
    gap:20px;
    
    h1{
        color:#01a479;
        text-transform:uppercase;
    }

    .projectsContainer{
        width:80%;
        margin:auto;
        display:flex;
        align-items:center;
        flex-direction:column;
    }

    .box{
        position:relative;
        width:100%;
        height:450px;
        display:flex;
        gap:10px;
        margin-bottom:80px;
        border: 10px solid #e9e9e9;
        border-radius: 20px;
        overflow:hidden;
        background: white;
        cursor: pointer;
    }

    .imgBox{
        width:50%;
        overflow:hidden;
    }

    
    .imgBox>img{
        display: block;
        transition: transform .4s; 
    }

    
    .ContentBox{
        width:50%;
        text-align:left;
        padding:0px 20px 20px 20px;
        
    }

    .ContentBox>h1{
        color:#343a40;
    }

    .ContentBox>p{
        width:90%;
        font-size:large;
        margin-top:0px;
    }

    .tagsBox{
        width:80%;
        display:flex;
        align-items:center;
        flex-wrap: wrap;
        line-height:20px;
        gap:5px;
        margin-bottom:20px;
    }

    .tagsBox>span{
        color:white;
        background-color:#01a479;
        padding: 2px 15px 2px 15px;
        border-radius:10px;
        font-size:13px;
        cursor: pointer;
    }


    .linkSection{
        display:flex;
        gap:20px;
    }

    .linkSection>a{
        text-decoration:none;
    }
    .linkSection>a:first-child>button{
        background-color:black;
        color: White;
        padding:8px 20px 8px 20px;
        border-radius:8px;
        font-weight:bold;
        display:flex;
        align-items:center;
        justify-content:center;
        gap:10px;
        border:none;
        cursor:pointer;
    }

    button{
        cursor:pointer;
    }

    button:hover{
        transform: translateY(-2px);
        transition: all 0.5s;
    }
    

    .linkSection>a:last-child>button{
        background-color:#44a4be;
        color: White;
        padding:8px 20px 8px 20px;
        border-radius:8px;
        border:none;
        font-weight:bold;
        display:flex;
        align-items:center;
        justify-content:center;
        gap:10px;
    }

    @media only screen and (min-width: 768px) and (max-width:1120px){
        .box{
            flex-direction:column;
            align-items:center;
            height:100%;
        }
 
        .projectsContainer{
            width:80%;
            margin:auto;
            
        }
        
        .imgBox{
            width:100%;
            height:400px;
        }

        .imgBox>img{
            width:100%;
        }

        .ContentBox{
            width:80%;
            display:flex;
            align-items:center;
            justify-content:center;
            flex-direction:column;
        }

        .ContentBox>h1{
            font-size:x-large;
        }

        .ContentBox>p{
            font-size:15px;
        }

        .tagsBox{
            width:100%;
            justify-content:center;
        }
    }

    @media only screen and (min-width: 481px) and (max-width:768px){
        .box{
           flex-direction:column;
           align-items:center;
           height:100%;
        }

        .projectsContainer{
            width:80%;
            margin:auto;
            
        }
        
        .imgBox{
            width:100%;
            height:280px;
        }

        .imgBox>img{
            width:100%;
        }

        .ContentBox{
            width:80%;
            display:flex;
            align-items:center;
            justify-content:center;
            flex-direction:column;
            text-align:center;
        }

        .ContentBox>h1{
            font-size:x-large;
        }

        .ContentBox>p{
            font-size:15px;
        }

        .tagsBox{
            width:100%;
            justify-content:center;
        }
    }


    @media only screen and (min-width:320px) and (max-width:480px){
        .box{
            flex-direction:column;
            align-items:center;
            height:100%;
        }

        .projectsContainer{
            width:90%;
            margin:auto;
            
        }

        .imgBox{
            width:100%;
            height:200px;
        }

        .imgBox>img{
            width:100%;
        }

        .ContentBox{
            width:80%;
            display:flex;
            align-items:center;
            justify-content:center;
            flex-direction:column;
            text-align:center;
        }

        .ContentBox>h1{
            font-size:large;
        }

        .ContentBox>p{
            font-size:13px;
            
        }


        .tagsBox{
            width:100%;
            justify-content:center;
        }
    }

    @media only screen and (max-width: 319px){
        .box{
            flex-direction:column;
            align-items:center;
            height:100%;
        }

        .projectsContainer{
            width:90%;
            margin:auto;
            
        }

        .imgBox{
            width:100%;
            height:150px;
        }

        .imgBox>img{
            width:100%;
            
        }

        .ContentBox{
            width:80%;
            display:flex;
            align-items:center;
            justify-content:center;
            flex-direction:column;
            text-align:center;
        }

        .ContentBox>h1{
            font-size:large;
        }

        .ContentBox>p{
            font-size:13px;
        }


        .tagsBox{
            width:100%;
            justify-content:center;
        }
    }
`
export default Projects